
export const schweinenackenBurger = {
	name: 'Saftig zarter BBQ Schweinenacken gezupft ',
	desc: 'Hamburger Sesambrötchen XXL, Farmermixsalat und Pommes frites.',
	image: 9,
	opinions: [
		{
			name: 'Martin Menzel',
			date: '14. April 2017',
			title: 'Ein Burger halt',
			content: 'Ich steh ja nicht so auf Burger',
			rating: 2,
		},
	],
	recommandation: 'Ein Joghurt als Nachtisch liefert noch etwas Calcium und hilft dem Magen bei der Verdauung.',
	warnings: ['schwein', 'weizen', 'gluten', 'zucker', 'fleischAllgemein', 'sesam', 'soja', 'laktose'],
	ingredients: [
		{'Schweinenacken': 'schwein, fleischAllgemein'},
		{'Sesamöl': 'sesam'},
		{'Sojasauce': 'soja'},
		'Essig',
		{'Zucker': 'zucker'},
		'Chilli',
		'Salz',
		'Pfeffer',
		{'Weizenmehl': 'weizen, gluten'},
		{'Frischhefe': 'hefe'},
		{'Käse': 'laktose'},
		{'Butter': 'laktose'},
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/schweinenackenBurger.js